/*
 * AddEditGroup Messages
 *
 * This contains all the text for the AddEditGroup component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.AddEditGroup';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
});
